import React from "react";
import { FormattedMessage } from "react-intl";

/**
 * Nagłowek strony
 * 
 * @param {string} id textu do wyświetlenia 
 */
export const PageHeader = ({ text }) => {
  return (
    <div>
      <h4>
        <FormattedMessage id={text} defaultMessage="Page title" />
      </h4>
      <hr />
    </div>
  );
};
